export default "__VITE_ASSET__b1708845__"